<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Loan Type</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Loan</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Loan Type</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Type Name</th>
                      <th>Interest Rate %</th>
                      <th>Include Amount Policy</th>
                      <th>Max Tenor</th>
                      <th>GL Account</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in loanTypes" v-bind:key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.description }}</td>
                      <td>{{ item.interestRate }}</td>
                      <td>{{ item.calculatedRequestAmount ? 'Yes' : 'No' }}</td>
                      <td>{{ item.tenor }}</td>
                      <td>{{ item.glAccount }}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectLoanType(item)"
                              data-target="#edit_termination_type"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectLoanType(item)"
                              data-target="#delete_department"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div
          id="add_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Loan Type</h5>
                <button
                  type="button"
                  class="close"
                  id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Type Name <span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.description.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.description.$error
                      }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.description.required"
                      class="invalid-feedback"
                    >
                      Loan Type name is required
                    </div>
                  </div>
                  <div class="form-group with-switch">
                    
                      <input
                        type="checkbox"
                        v-model.trim="$v.calculatedRequestAmount.$model"
                      />
                      <label>Do you have amount for this type of loan?</label>
                  </div>
                  <div class="form-group">
                    <label
                      >Interest Rate % <span class="text-danger">*</span></label
                    >
                    <input
                      v-model.trim="$v.interestRate.$model"
                      id="interestRate"
                      name="interestRate"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.interestRate.$error
                      }"
                      type="number"
                    />
                    <div
                      v-if="submitted && !$v.interestRate.required"
                      class="invalid-feedback"
                    >
                      Interest Rate is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      >Max Tenor (per month)
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model.trim="$v.tenor.$model"
                      id="tenor"
                      name="tenor"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.tenor.$error }"
                      type="number"
                    />
                    <div
                      v-if="submitted && !$v.tenor.required"
                      class="invalid-feedback"
                    >
                      Tenor is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      >GL Account
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model.trim="$v.glAccount.$model"
                      id="tenor"
                      name="tenor"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.glAccount.$error }"
                      type="number"
                    />
                    <div
                      v-if="submitted && !$v.glAccount.required"
                      class="invalid-feedback"
                    >
                      GL Account is required
                    </div>
                  </div>
                  <div class="submit-section">
                    <button
                      class="btn btn-primary submit-btn"
                      :disabled="submitted"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div
          id="edit_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Loan Type</h5>
                <button
                  type="button"
                  class="close"
                  id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Type Name <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    v-model="loanType.description"
                    id="description"
                    name="description"
                    class="form-control"
                  />
                </div>
                <div class="form-group with-switch">
                    
                      <input
                        type="checkbox"
                        v-model.trim="loanType.calculatedRequestAmount"
                      />
                      <label>Do you have amount for this type of loan?</label>
                  </div>
                <div class="form-group">
                  <label
                    >Interest Rate % <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    v-model="loanType.interestRate"
                    id="interestRate"
                    name="interestRate"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Max Tenor (per month)
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    v-model="loanType.tenor"
                    id="tenor"
                    name="tenor"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label
                    >GL Account
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="number"
                    v-model="loanType.glAccount"
                    id="tenor"
                    name="tenor"
                    class="form-control"
                  />
                </div>
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_department"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Loan Type</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="onDeleteSubmit"
                        class="btn btn-primary continue-btn"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        data-dismiss="modal"
                        id="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },

  data() {
    return {
      description: "",
      calculatedRequestAmount: false,
      interestRate: 0,
      tenor: 0,
      glAccount: '',
      loanType: {},
      loanTypes: [],
      submitted: false,
      loading: false,
      error: "",
      company: authenticationService.currentOfficeValue
    };
  },

  validations: {
    description: { required },
    calculatedRequestAmount: { required },
    interestRate: { required },
    tenor: { required },
    glAccount: { required }
  },

  methods: {
    selectLoanType(item) {
      this.loanType = item;
    },

    getLoanTypes() {
      employeeService.getLoanTypes(this.company.id).then(
        model => {
          this.loanTypes = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      //console.log(this.name)
      var req = {
        description: this.description,
        companyId: this.company.id,
        calculatedRequestAmount: this.calculatedRequestAmount,
        interestRate: this.interestRate,
        tenor: this.tenor,
        glAccount: this.glAccount
      };
      employeeService.addLoanType(req).then(
        id => {
          employeeService.getLoanTypes(this.company.id).then(r => {
            this.loanTypes = r;
            console.log(r);
            $("#close").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      console.log(this.loanType);
      this.loading = true;
      employeeService.updateLoanType(this.loanType).then(
        id => {
          employeeService.getLoanTypes(this.company.id).then(r => {
            this.loanTypes = r;
            $("#closeEdit").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onDeleteSubmit() {
      console.log(this.loanType);
      this.loading = true;
      employeeService.removeLoanType(this.loanType.id).then(
        id => {
          employeeService.getLoanTypes(this.company.id).then(r => {
            this.loanTypes = r;
            $("#closeDelete").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getLoanTypes();
    //this.removeSkillType(this.company.id);
    // Datatable

    // if ($(".datatable").length > 0) {
    //   $(".datatable").DataTable({
    //     bFilter: false,
    //   });
    // }
    
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "terminationtype"
};
</script>



// WEBPACK FOOTER //
// src/components/loans/loanType.vue